import { Data } from "pages/Corporate/components/BarChart/BarsChartInterfaces";
import { useTheme } from "@mui/material";
import { useStyles } from "./ReportDowntimeBarChart.styles";
import { IReportDowntimeBarChartValue } from "./ReportDowntimeBarChartInterfaces";

interface ITotalDowntime {
    key: string;
    trendValue: number;
    [key: string]: number | string;
    totalDowntimeByMill: number;
}

export const ReportDowntimeBarChartTrendLayer = ({ bars, width }: IReportDowntimeBarChartValue) => {
    const themeStyles = useTheme();
    const classes = useStyles();
    const barData = [] as {
        y: number;
        value: ITotalDowntime;
    }[];
    const trendExtraYSpace = 8;
    bars.forEach(({ data: { data }, y }: Data) => {
        const currentXOnItem = barData.find((item) => item.y === y + trendExtraYSpace);

        if (!currentXOnItem) {
            barData.push({ y: y + trendExtraYSpace, value: data as ITotalDowntime });
        }
    });

    return barData.map((bar, index: number) => {
        return (
            <g transform={`translate(${width! - 95}, ${bar.y})`} key={`${bar.value.key}-${index}`}>
                <text
                    x={bar.value.trendValue ? 0 : 18}
                    y={0}
                    textAnchor="middle"
                    dominantBaseline="middle"
                    className={bar.value.trendValue ? "" : classes.trendSame}
                    style={{
                        fill: themeStyles.palette.text.primary,
                        fontSize: 10,
                        fontFamily: "Source Sans 3",
                    }}
                >
                    {`${bar.value.trendValue ? `${bar.value.trendValue}%` : "----"}`}
                </text>
                {bar.value.trendValue && (
                    <path
                        className={bar.value.trendValue > 0 ? classes.trendUp : classes.trendDown}
                        d="M11 6.83 9.41 8.41 8 7l4-4 4 4-1.41 1.41L13 6.83V21h-2z"
                    />
                )}
            </g>
        );
    });
};
